import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

const CalendarSheet = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}) => (
  <SheetContainer>
    <CalendarInnerSheet style={style}>{children}</CalendarInnerSheet>
  </SheetContainer>
);

const SheetContainer = styled.View`
  flex: 1;
  flex-direction: row;
  justify-content: center;
  padding: 16px;
  padding-top: 0px;
`;

const CalendarInnerSheet = styled(View)`
  flex-direction: row;
  flex: 1;
  background-color: white;
  border-radius: 20px;
`;

export default CalendarSheet;
